let Promise = require('bluebird');
let Vue = require('vue');

module.exports = () => new Promise((resolve, reject) => {
    Vue.component("buildings_count", {
        template: `
            <div class="grid-item col-xs-12 col-sm-6 col-md-6 col-lg-3">
                <a class="dashboard-stat dashboard-stat-light widget-imoveis" v-bind:href="'/buildings' | url">
                    <div class="visual">
                        <i class="fa fa-building-o"></i>
                    </div>
                    <div class="details">
                        <div class="number">
                             <span class="mynumber">{{data.info.count}}</span>/{{data.info.total}}
                        </div>
                        <div class="desc">
                             Meus empreendimentos / Totais
                        </div>
                    </div>
                    </a>
            </div>
        `,
        props: ["alias", "data"]
    });

    resolve();
});


// WEBPACK FOOTER //
// ./resources/assets/javascript/sci/widgets/buildings_count.js